<template>
  <div class="calc-desenquadramento-mei-results">
    <h2>Calculadora desenquadramento MEI</h2>
    <p class="calc-desenquadramento-mei-results__subtitle">Descubra a melhor opção para sua empresa.</p>

    <div
    id="loading"
    :class="{'loading--show': loading}"
    class="loading"
    >
      <span class="spinner" />
      <h3>Aguarde</h3>
      <p>Calculando...</p>
    </div>

    <div class="box-resultados">
      <p class="paragraph-check-results">Confira abaixo a simulação*</p>

      <ul class="info-anos">
        <IconCheck
          v-if="resume.corIcone === '#04C377'"
          :cor="resume.corIcone"
        />
        <IconAlert
          v-else
          :cor="resume.corIcone"
        />
        <li v-html="this.replaceAnoAnterior(resume.anoAnterior)"/>
        <li v-html="this.replaceAnoAtual(resume.anoAtual)"/>
      </ul>

      <div class="results-numbers" :class="{'results-numbers--minimo': diferencaMinima < 21000 || faturamentoPrevisao > 50000}" id="box" ref="box">
        <Progressbar
          :value="faturamentoAcumulado"
          :valuePrevisao="faturamentoPrevisao"
          :final="valorMaximo"
          :limite="valorLimite"
          :limiteMaisVinte="valorLimiteMaisVinte"
          :faturamentoAcumuladoLegenda="legendaAcumulado"
        />
      </div>

      <div class="imposto-complementar" v-if="impostoComplmentar">
        <p>Imposto complementar devido {{this.formatNumber(impostoComplmentar)}}</p>
      </div>

      <a @click="resetCalc" class="restart-simulation">Refazer simulação</a>
    </div>
    <div class="politica-responsibilidade">
      <p>{{this.politicaResponsabilidade}}</p>
    </div>

    <ul class="informativo-list">
      <li v-for="(informativo, index) in informativos" :key="index" >
        <ToggleListItem :informativo="informativo"></ToggleListItem>
      </li>
    </ul>

    <ButtomPrimary
      :texto="'FALE COM UM ESPECIALISTA'"
      class="actions__continue"
      :deepClass="'blue-normal'"
      v-if="this.cta"
      @click="() => {
        enviarGa();
        specialistTrigger();
      }"
    />
  </div>
</template>
<script>
import ButtomPrimary from '@/components/ButtomPrimary'
import ToggleListItem from '@/components/ToggleListItem'
import Progressbar from '@/components/ProgressBar'
import IconCheck from '@/components/IconCheck';
import IconAlert from '@/components/IconAlert';

export default {
  components: {
    ButtomPrimary,
    ToggleListItem,
    Progressbar,
    IconCheck,
    IconAlert
  },

  data() {
    return {
      informativos: this.results.data.descricaoCompletaCalculo,
      loading: false,
      isActive: false,
      cta: this.results.data.cta,
      valorMaximo: this.results.data.valoresCorte[3],
      valorLimite: this.results.data.valoresCorte[1],
      valorLimiteMaisVinte: this.results.data.valoresCorte[2],
      politicaResponsabilidade: this.results.data.politicaResponsabilidade,
      resume: this.results.data.descricaoResumidaCalculo,
      faturamentoAcumulado: this.results.data.faturamentoAcumulado,
      faturamentoPrevisao: this.results.data.previsaoFaturamentoAnoAtual,
      impostoComplmentar: this.results.data.impostoComplementarDevido,
      diferencaMinima: this.results.data.previsaoFaturamentoAnoAtual - this.results.data.faturamentoAcumulado,
      legendaAcumulado: this.results.data.legendaFaturamentoAcumulado
    }
  },
  props: {
    results: {
      type: Object,
      default: () => null
    }
  },
  methods: {
    specialistTrigger() {
      if (window.openModal) {
        window.openModal();
      } else {
        location.href = '/desenquadrar-mei-para-me/';
      }
    },
    replaceAnoAnterior(text) {
      const date = new Date()
      const anoAnterior = date.getFullYear() - 1;
      const anoAnteriorSpan = `<span class="year">  ${anoAnterior} </span>`;
      return text.replace("{anoAnteriorCustomizado}", anoAnteriorSpan)
    },
    replaceAnoAtual(text){
      const date = new Date()
      const anoAtual = date.getFullYear()
      const anoAtualSpan = `<span class="year">  ${anoAtual} </span>`;
      return text.replace("{anoAtualCustomizado}", anoAtualSpan)
    },
    resetCalc() {
      this.$emit('onResults', null)
      dataLayer.push({
        event: 'customEvent',
        eventCategory: `site:calculadora-desenquadramento-mei`,
        eventAction: 'click:calculadora-resultado',
        eventLabel: `refazer-simulacao`
      })
    },
    enviarGa() {
      dataLayer.push({
        event: 'customEvent',
        eventCategory: `site:calculadora-desenquadramento-mei`,
        eventAction: 'click:calculadora-resultado',
        eventLabel: `fale-com-um-especialista`
      })
    },
    formatNumber(value) {
      return  new Intl
              .NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
              .format(value)
    }
  },
}

</script>
<style lang="scss" src="./CalculatorResults.styles.scss" scoped></style>
